import SessionEventProto from "../session-event-proto"
import Resource from "../../model2/resource/resource"
import {EVENT_BUS_SESSION_RESOURCES_CHANGED} from "./@const"


export default class SessionEvent_ResourceNew extends SessionEventProto {

    constructor(sessionEvent: any) {
        super(sessionEvent)
    }

    process() {
        const resource = new Resource(this.data)

        if (gd.session.resources.get(resource.id)) {
            gd.session.resources.get(resource.id)!.applyDelta(this.data)
        } else {
            gd.session.resources.add(resource)
        }

        gd.bus.triggerEvent(EVENT_BUS_SESSION_RESOURCES_CHANGED)
    }
}
